// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZjXhhwutZvVyxKyRvmemqc8OZtcntZgc",
  authDomain: "chat-app-cc8b0.firebaseapp.com",
  projectId: "chat-app-cc8b0",
  storageBucket: "chat-app-cc8b0.appspot.com",
  messagingSenderId: "397183951717",
  appId: "1:397183951717:web:f60a9410b3e4c9ff3ff78c",
  measurementId: "G-0K0952NJN0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);